import { ComponentProps, HTMLAttributes, PropsWithChildren } from "react";
import { FeedSection } from "@pages/Section/utils/types";
import Card from "@particles/card/Card";
import { OKTAUserType } from "@store/useOKTAUserStore";
import { SanitizedSectionArticle, Tag } from "@typings/Cue";

export enum MyAccountTabsEnum {
  "myBT" = "myBT",
  "recent" = "Recently Read",
}

export type useGetMyBTArticleListProps = {
  tags: Tag[];
  tagSize?: number;
  size?: number;
};

export type myBTTagsWithArticle = {
  tag: Tag;
  articles: SanitizedSectionArticle[];
};

export type MyAccountActiveProps = {
  activeTab: MyAccountTabsEnum;
};

export type MyAccountTabsProps = {
  activeTab: MyAccountTabsEnum;
  handleTabChange: React.Dispatch<React.SetStateAction<MyAccountTabsEnum>>;
} & Pick<HTMLAttributes<HTMLDivElement>, "className">;

export type MyAccountPopoverMyBTProps = {
  firstCharOfLogin?: string;
};

export type MyAccountMyBTAccordionProps = {
  title: string;
} & PropsWithChildren &
  Pick<HTMLAttributes<HTMLDivElement>, "className">;

export type MyAccountMyBTPageListProps = {
  tagWithArticleList: myBTTagsWithArticle[];
  loadMoreRef?: (node?: Element | null | undefined) => void;
};

export type MyAccounMyBTPopoverListProps = {
  tagWithArticleList: myBTTagsWithArticle[];
};

export type MyAccountMyBTBasicCardProps = {
  article: SanitizedSectionArticle;
};

export type MyAccountMyBTTagFilterProps = {
  tagList: string[];
  activeFilter: string;
  setActiveFilter: (tagName: string) => void;
};

export type MyAccountReadingHistoryBasicCardPopoverProps = {
  article: SanitizedSectionArticle;
};

export type GaObject = {
  event: string;
  eventCategory: string;
  eventAction: string;
  eventLabel: string;
  user_keyword?: string;
};

export type MyAccountPageSettingProps = {
  /** OKTA User Info */
  oktaUserInfo?: OKTAUserType;
};

export type useGetRecentArticleListProps = {
  /** Page size of articles to display per scroll */
  pageSize: number;
};

export type MyAccountReadingHistoryPopoverProps = {
  /** The list of article to dispay */
  articleList: ComponentProps<typeof Card>[];
  /** Indicator to display view more link */
  isDisplayViewMore?: boolean;
};

export type MyAccountReadingHistoryProps = {
  /** The list of article to dispay */
  articleList: ComponentProps<typeof Card>[];
  /** Compenent ref to load more */
  loadMoreRef?: (node?: Element | null | undefined) => void;
  /** Callback to handle delete article */
  handleDeleteArticle: (articleId: string) => void;
  /** List of article Id that is being deleted */
  deleteArticleIdList: string[];
};

export type FeedReadingHistoryStore = {
  /** List of recent read article Ids */
  articleList: ComponentProps<typeof Card>[];
  /** Function to set the article Id list */
  setArticleId: (articleIdList: ComponentProps<typeof Card>) => void;
  /** Function to delete article Id from the list */
  deleteArticleId: (articleId: ComponentProps<typeof Card>) => void;
};

export type FeedReadingHistoryData = {
  /** The recent read article id */
  articleId: string;
  /** The date which use read */
  readAt: string;
  /** The Article url of the recent read */
  articleUrl: string;
  /** The published time stamp of the article*/
  publishedTime: string;
  /** The edited time stamp of the articles */
  editedTime: string;
  /** The section details */
  sections?: FeedSection[];
  /** The title of the article */
  title: string;
  /** The platform from which the article was read */
  platform: string;
};

export type FeedSetReadingHistoryResponse = {
  /** Timestamp which user read */
  timeStamp: string;
};

export type FeedDeleteReadingHistoryResponse = {
  /** Successful message from BE */
  message: string;
};
